import baseURL from "../Api/baseURL";

const loggedUser = JSON.parse(localStorage.getItem("user"));

const token = loggedUser?.token;

export const useDeleteData = async (url, params = {}) => {
  const res = await baseURL.delete(url, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : { is_admin: true }),
    },
    params,
  });

  return res.data;
};
